<template>
  <div class="evaluation">
    <b-row v-if="!token" class="mb-3">
      <b-col cols="12">
        <b-button variant="primary" @click="generateToken"
          ><i class="fas fa-qrcode mr-2" />{{
            $t("actions.generate_token")
          }}</b-button
        >
        <b-button variant="default" class="ml-3" @click="ladeDaten"
          ><i class="fas fa-sync"
        /></b-button>
        <b-link
          href="/mitarbeiterverwaltun/laufzettel/"
          target="_top"
          class="btn btn-default ml-3"
          ><i class="fas fa-list mr-3" />{{ $t("actions.to_list") }}</b-link
        >
      </b-col>
      <b-col cols="12" class="mt-3">
        <b-alert
          show
          variant="warning"
          v-html="$t('formular.warn_readonly')"
        ></b-alert>
      </b-col>
    </b-row>

    <bx-box variant="gray" header-class="col-md-8" class="mb-3">
      <template #header>
        <h3>{{ formular_text("headline") }}</h3>
      </template>
      <bx-box variant="white" body-class="p-3">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-skeleton-img height="350px"></b-skeleton-img>
          </template>
          <b-row>
            <b-col md="4">
              <b-form-group :label="formular_text('name')">
                <b-input
                  type="text"
                  disabled
                  :value="employee | display_name"
                  size="sm"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-skeleton-wrapper>
      </bx-box>
    </bx-box>

    <h6>{{ formular_text("belehrung_bereiche_headline") }}</h6>
    <bx-box variant="gray" header-class="col-md-8" class="mb-3">
      <bx-box variant="white" body-class="p-3">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-skeleton-img height="350px"></b-skeleton-img>
          </template>

          <table class="table table-bordered belehrungen-table">
            <b-tr>
              <b-td rowspan="3"
                ><strong>{{ formular_text("hr_department") }}</strong></b-td
              >
              <b-td>{{ formular_text("qm_system") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="qm_system_date"
                  :disabled="qm_system_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td class="signature-field" @click="openSignature('qm_system')">
                <div
                  v-if="!qm_system_signature"
                  class="signature-placeholder"
                ></div>
                <img v-if="qm_system_signature" :src="qm_system_signature" />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ formular_text("betriebsausweis") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="betriebsausweis_date"
                  :disabled="betriebsausweis_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('betriebsausweis')"
              >
                <img
                  v-if="betriebsausweis_signature"
                  :src="betriebsausweis_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ formular_text("documents") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="dokumente_date"
                  :disabled="dokumente_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td class="signature-field" @click="openSignature('dokumente')">
                <img v-if="dokumente_signature" :src="dokumente_signature" />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                ><strong>{{ formular_text("accounting") }}</strong></b-td
              >
              <b-td></b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="buchhaltung_date"
                  :disabled="buchhaltung_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('buchhaltung')"
              >
                <img
                  v-if="buchhaltung_signature"
                  :src="buchhaltung_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                ><strong>{{ formular_text("cashbox") }}</strong></b-td
              >
              <b-td>{{ formular_text("cashbox_2") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="kasse_date"
                  :disabled="kasse_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td class="signature-field" @click="openSignature('kasse')">
                <img v-if="kasse_signature" :src="kasse_signature" />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td rowspan="2"
                ><strong>{{ formular_text("verkehrsplanung") }}</strong></b-td
              >
              <b-td>{{ formular_text("einweisung_tarifsystem") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="einweisung_tarifsystem_date"
                  :disabled="einweisung_tarifsystem_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('einweisung_tarifsystem')"
              >
                <img
                  v-if="einweisung_tarifsystem_signature"
                  :src="einweisung_tarifsystem_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ formular_text("fahrscheinsortiment") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="fahrscheinsortiment_date"
                  :disabled="fahrscheinsortiment_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('fahrscheinsortiment')"
              >
                <img
                  v-if="fahrscheinsortiment_signature"
                  :src="fahrscheinsortiment_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td rowspan="2"
                ><strong>{{ formular_text("fuhrpark") }}</strong></b-td
              >
              <b-td>{{ formular_text("sozialvorschriften") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="sozialvorschriften_date"
                  :disabled="sozialvorschriften_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('sozialvorschriften')"
              >
                <img
                  v-if="sozialvorschriften_signature"
                  :src="sozialvorschriften_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ formular_text("arbeits_umweltschutz") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="arbeits_umweltschutz_date"
                  :disabled="arbeits_umweltschutz_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('arbeits_umweltschutz')"
              >
                <img
                  v-if="arbeits_umweltschutz_signature"
                  :src="arbeits_umweltschutz_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td rowspan="2"
                ><strong>{{ formular_text("werkstatt") }}</strong></b-td
              >
              <b-td>{{ formular_text("werkstatt_arbeitsablaeufe") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="werkstatt_arbeitsablaeufe_date"
                  :disabled="werkstatt_arbeitsablaeufe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('werkstatt_arbeitsablaeufe')"
              >
                <img
                  v-if="werkstatt_arbeitsablaeufe_signature"
                  :src="werkstatt_arbeitsablaeufe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ formular_text("werkstatt_arbeitsbelehrung") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="werkstatt_arbeitsbelehrung_date"
                  :disabled="werkstatt_arbeitsbelehrung_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('werkstatt_arbeitsbelehrung')"
              >
                <img
                  v-if="werkstatt_arbeitsbelehrung_signature"
                  :src="werkstatt_arbeitsbelehrung_signature"
                />
              </b-td>
            </b-tr>
          </table>
        </b-skeleton-wrapper>
      </bx-box>
    </bx-box>

    <h6>{{ formular_text("weitere_belehrungen") }}</h6>
    <bx-box variant="gray" header-class="col-md-8" class="mb-3">
      <bx-box variant="white" body-class="p-3">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-skeleton-img height="350px"></b-skeleton-img>
          </template>

          <table class="table table-bordered weitere-belehrungen-table">
            <b-tr>
              <b-th></b-th>
              <b-th></b-th>
              <b-th>{{ $t("common.date") }}</b-th>
              <b-th>{{ $t("common.signature") }}</b-th>
            </b-tr>
            <b-tr>
              <b-td colspan="2">{{ formular_text("betriebsordnung") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="betriebsordnung_date"
                  :disabled="betriebsordnung_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('betriebsordnung')"
              >
                <img
                  v-if="betriebsordnung_signature"
                  :src="betriebsordnung_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="2">{{
                formular_text("betriebsverkehrsordnung")
              }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="betriebsverkehrsordnung_date"
                  :disabled="betriebsverkehrsordnung_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('betriebsverkehrsordnung')"
              >
                <img
                  v-if="betriebsverkehrsordnung_signature"
                  :src="betriebsverkehrsordnung_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="2">{{
                formular_text("tarifangelegenheiten")
              }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="tarifangelegenheiten_date"
                  :disabled="tarifangelegenheiten_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('tarifangelegenheiten')"
              >
                <img
                  v-if="tarifangelegenheiten_signature"
                  :src="tarifangelegenheiten_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="2">{{
                formular_text("fahrzeugbordrechner")
              }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="fahrzeugbordrechner_date"
                  :disabled="fahrzeugbordrechner_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('fahrzeugbordrechner')"
              >
                <img
                  v-if="fahrzeugbordrechner_signature"
                  :src="fahrzeugbordrechner_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="2">{{
                formular_text("monats_wochen_tagesplan")
              }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="monats_wochen_tagesplan_date"
                  :disabled="monats_wochen_tagesplan_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('monats_wochen_tagesplan')"
              >
                <img
                  v-if="monats_wochen_tagesplan_signature"
                  :src="monats_wochen_tagesplan_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td colspan="2">{{ formular_text("fahrzeugeinweisung") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="fahrzeugeinweisung_date"
                  :disabled="fahrzeugeinweisung_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('fahrzeugeinweisung')"
              >
                <img
                  v-if="fahrzeugeinweisung_signature"
                  :src="fahrzeugeinweisung_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td rowspan="4">{{ formular_text("einweisung_ueber") }}</b-td>
              <b-td>{{ formular_text("einweisung_tanken") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="einweisung_tanken_date"
                  :disabled="einweisung_tanken_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('einweisung_tanken')"
              >
                <img
                  v-if="einweisung_tanken_signature"
                  :src="einweisung_tanken_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ formular_text("einweisung_einzahlungen") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="einweisung_einzahlungen_date"
                  :disabled="einweisung_einzahlungen_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('einweisung_einzahlungen')"
              >
                <img
                  v-if="einweisung_einzahlungen_signature"
                  :src="einweisung_einzahlungen_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ formular_text("einweisung_abrechnung") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="einweisung_abrechnung_date"
                  :disabled="einweisung_abrechnung_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('einweisung_abrechnung')"
              >
                <img
                  v-if="einweisung_abrechnung_signature"
                  :src="einweisung_abrechnung_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ formular_text("einweisung_rbl") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="einweisung_rbl_date"
                  :disabled="einweisung_rbl_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('einweisung_rbl')"
              >
                <img
                  v-if="einweisung_rbl_signature"
                  :src="einweisung_rbl_signature"
                />
              </b-td>
            </b-tr>
          </table>
        </b-skeleton-wrapper>
      </bx-box>
    </bx-box>

    <h6>{{ formular_text("empfang_rueckgabe") }}</h6>
    <bx-box variant="gray" header-class="col-md-8" class="mb-3">
      <bx-box variant="white" body-class="p-3">
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <b-skeleton-img height="350px"></b-skeleton-img>
          </template>

          <table class="table table-bordered laufzettel-table">
            <b-tr>
              <b-th rowspan="2"></b-th>
              <b-td class="py-1">{{ formular_text("erhalt") }}</b-td>
              <b-th class="py-1">{{ $t("common.signature") }}</b-th>
              <b-td class="py-1">{{ formular_text("rueckgabe") }}</b-td>
              <b-th class="py-1">{{ $t("common.signature") }}</b-th>
            </b-tr>
            <b-tr>
              <b-td class="py-1">{{ $t("common.date") }}</b-td>
              <b-th class="py-1">{{ formular_text("employee") }}</b-th>
              <b-td class="py-1">{{ $t("common.date") }}</b-td>
              <b-th class="py-1">{{ formular_text("foreman") }}</b-th>
            </b-tr>
            <b-tr>
              <b-td>{{ formular_text("betriebsschluessel") }}</b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="betriebsschlussel_ausgabe_date"
                  :disabled="betriebsschlussel_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('betriebsschlussel_ausgabe')"
              >
                <img
                  v-if="betriebsschlussel_ausgabe_signature"
                  :src="betriebsschlussel_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="betriebsschlussel_rueckgabe_date"
                  :disabled="betriebsschlussel_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('betriebsschlussel_rueckgabe')"
              >
                <img
                  v-if="betriebsschlussel_rueckgabe_signature"
                  :src="betriebsschlussel_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                >{{ formular_text("transponder_schliesssystem") }}
                <b-input
                  :placeholder="$t('common.number')"
                  v-model="transponder_schliesssystem_nummer"
                  size="sm"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="transponder_schliesssystem_ausgabe_date"
                  :disabled="
                    transponder_schliesssystem_ausgabe_signature !== null
                  "
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('transponder_schliesssystem_ausgabe')"
              >
                <img
                  v-if="transponder_schliesssystem_ausgabe_signature"
                  :src="transponder_schliesssystem_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="transponder_schliesssystem_rueckgabe_date"
                  :disabled="
                    transponder_schliesssystem_rueckgabe_signature !== null
                  "
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('transponder_schliesssystem_rueckgabe')"
              >
                <img
                  v-if="transponder_schliesssystem_rueckgabe_signature"
                  :src="transponder_schliesssystem_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                >{{ formular_text("rfid_im_transponder") }}

                <b-form-radio
                  v-model="rfid_im_transponder_hinterlegt"
                  name="rfid_im_transponder"
                  inline
                  :value="true"
                >
                  {{ $t("common.yes") }}
                </b-form-radio>
                <b-form-radio
                  v-model="rfid_im_transponder_hinterlegt"
                  name="rfid_im_transponder"
                  inline
                  :value="false"
                >
                  {{ $t("common.no") }}
                </b-form-radio>
                <b-input
                  v-if="rfid_im_transponder_hinterlegt"
                  :placeholder="$t('common.number')"
                  v-model="rfid_im_transponder"
                  size="sm"
                  :disabled="rfid_im_transponder_ausgabe_signature !== null"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="rfid_im_transponder_ausgabe_date"
                  :disabled="rfid_im_transponder_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('rfid_im_transponder_ausgabe')"
              >
                <img
                  v-if="rfid_im_transponder_ausgabe_signature"
                  :src="rfid_im_transponder_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="rfid_im_transponder_rueckgabe_date"
                  :disabled="rfid_im_transponder_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('rfid_im_transponder_rueckgabe')"
              >
                <img
                  v-if="rfid_im_transponder_rueckgabe_signature"
                  :src="rfid_im_transponder_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                >{{ formular_text("tanktransponder_gesondert") }}
                <b-input
                  :placeholder="$t('common.number')"
                  v-model="tanktransponder_gesondert_rfid_nummer"
                  size="sm"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="tanktransponder_gesondert_ausgabe_date"
                  :disabled="
                    tanktransponder_gesondert_ausgabe_signature !== null
                  "
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('tanktransponder_gesondert_ausgabe')"
              >
                <img
                  v-if="tanktransponder_gesondert_ausgabe_signature"
                  :src="tanktransponder_gesondert_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="tanktransponder_gesondert_rueckgabe_date"
                  :disabled="
                    tanktransponder_gesondert_rueckgabe_signature !== null
                  "
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('tanktransponder_gesondert_rueckgabe')"
              >
                <img
                  v-if="tanktransponder_gesondert_rueckgabe_signature"
                  :src="tanktransponder_gesondert_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                >{{ formular_text("tresor") }}
                <b-input
                  :placeholder="$t('common.number')"
                  v-model="tresor_nummer"
                  size="sm"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="tresor_ausgabe_date"
                  :disabled="tresor_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('tresor_ausgabe')"
              >
                <img
                  v-if="tresor_ausgabe_signature"
                  :src="tresor_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="tresor_rueckgabe_date"
                  :disabled="tresor_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('tresor_rueckgabe')"
              >
                <img
                  v-if="tresor_rueckgabe_signature"
                  :src="tresor_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                >{{ formular_text("spind") }}
                <b-input
                  :placeholder="$t('common.number')"
                  v-model="spind_nummer"
                  size="sm"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="spind_ausgabe_date"
                  :disabled="spind_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('spind_ausgabe')"
              >
                <img
                  v-if="spind_ausgabe_signature"
                  :src="spind_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="spind_rueckgabe_date"
                  :disabled="spind_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('spind_rueckgabe')"
              >
                <img
                  v-if="spind_rueckgabe_signature"
                  :src="spind_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                >{{ formular_text("modul") }}
                <b-input
                  :placeholder="$t('common.number')"
                  v-model="modul_nummer"
                  size="sm"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="modul_ausgabe_date"
                  :disabled="modul_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('modul_ausgabe')"
              >
                <img
                  v-if="modul_ausgabe_signature"
                  :src="modul_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="modul_rueckgabe_date"
                  :disabled="modul_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('modul_rueckgabe')"
              >
                <img
                  v-if="modul_rueckgabe_signature"
                  :src="modul_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                >{{ formular_text("wechselgeld") }}
                <b-input-group size="sm" append="€">
                  <b-form-input
                    :placeholder="$t('common.amount')"
                    v-model.number="wechselgeld_betrag"
                  />
                </b-input-group>
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="wechselgeld_ausgabe_date"
                  :disabled="wechselgeld_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('wechselgeld_ausgabe')"
              >
                <img
                  v-if="wechselgeld_ausgabe_signature"
                  :src="wechselgeld_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="wechselgeld_rueckgabe_date"
                  :disabled="wechselgeld_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('wechselgeld_rueckgabe')"
              >
                <img
                  v-if="wechselgeld_rueckgabe_signature"
                  :src="wechselgeld_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ formular_text("kasseneinsatz") }} </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="kasseneinsatz_ausgabe_date"
                  :disabled="kasseneinsatz_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('kasseneinsatz_ausgabe')"
              >
                <img
                  v-if="kasseneinsatz_ausgabe_signature"
                  :src="kasseneinsatz_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="kasseneinsatz_rueckgabe_date"
                  :disabled="kasseneinsatz_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('kasseneinsatz_rueckgabe')"
              >
                <img
                  v-if="kasseneinsatz_rueckgabe_signature"
                  :src="kasseneinsatz_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ formular_text("dienstkleidung") }} </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="dienstkleidung_ausgabe_date"
                  :disabled="dienstkleidung_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('dienstkleidung_ausgabe')"
              >
                <img
                  v-if="dienstkleidung_ausgabe_signature"
                  :src="dienstkleidung_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="dienstkleidung_rueckgabe_date"
                  :disabled="dienstkleidung_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('dienstkleidung_rueckgabe')"
              >
                <img
                  v-if="dienstkleidung_rueckgabe_signature"
                  :src="dienstkleidung_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                >{{ formular_text("infoblatt_betriebliche_alertsvorsorge") }}
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="infoblatt_betriebliche_alertsvorsorge_date"
                  :disabled="
                    infoblatt_betriebliche_alertsvorsorge_signature !== null
                  "
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('infoblatt_betriebliche_alertsvorsorge')"
              >
                <img
                  v-if="infoblatt_betriebliche_alertsvorsorge_signature"
                  :src="infoblatt_betriebliche_alertsvorsorge_signature"
                />
              </b-td>
              <b-td class="disabled"> </b-td>
              <b-td class="disabled"> </b-td>
            </b-tr>
            <b-tr>
              <b-td
                >{{ formular_text("handynummer") }}
                <b-input
                  :placeholder="$t('common.number')"
                  v-model="handynummer"
                  size="sm"
                  type="tel"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="handynummer_ausgabe_date"
                  :disabled="handynummer_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('handynummer_ausgabe')"
              >
                <img
                  v-if="handynummer_ausgabe_signature"
                  :src="handynummer_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="handynummer_rueckgabe_date"
                  :disabled="handynummer_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('handynummer_rueckgabe')"
              >
                <img
                  v-if="handynummer_rueckgabe_signature"
                  :src="handynummer_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                >{{ formular_text("handy_privat") }}
                <b-form-radio
                  v-model="handy_privat"
                  name="handy_privat"
                  inline
                  :value="true"
                  class="ml-3"
                >
                  {{ $t("common.yes") }}
                </b-form-radio>
                <b-form-radio
                  v-model="handy_privat"
                  name="handy_privat"
                  inline
                  :value="false"
                >
                  {{ $t("common.no") }}
                </b-form-radio>
              </b-td>
              <b-td colspan="4"> </b-td>
            </b-tr>
            <b-tr>
              <b-td>{{ formular_text("fahrerdongle") }} </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="fahrerdongle_ausgabe_date"
                  :disabled="fahrerdongle_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('fahrerdongle_ausgabe')"
              >
                <img
                  v-if="fahrerdongle_ausgabe_signature"
                  :src="fahrerdongle_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="fahrerdongle_rueckgabe_date"
                  :disabled="fahrerdongle_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('fahrerdongle_rueckgabe')"
              >
                <img
                  v-if="fahrerdongle_rueckgabe_signature"
                  :src="fahrerdongle_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <b-tr>
              <b-td
                >{{ formular_text("imei") }}
                <b-input
                  :placeholder="$t('common.number')"
                  v-model="imei"
                  size="sm"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="imei_ausgabe_date"
                  :disabled="imei_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('imei_ausgabe')"
              >
                <img
                  v-if="imei_ausgabe_signature"
                  :src="imei_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="imei_rueckgabe_date"
                  :disabled="imei_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('imei_rueckgabe')"
              >
                <img
                  v-if="imei_rueckgabe_signature"
                  :src="imei_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <!-- -->
            <b-tr>
              <b-td
                >{{ formular_text("handy_sim") }}
                <b-input
                  :placeholder="$t('common.number')"
                  v-model="handy_sim"
                  size="sm"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="handy_sim_ausgabe_date"
                  :disabled="handy_sim_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('handy_sim_ausgabe')"
              >
                <img
                  v-if="handy_sim_ausgabe_signature"
                  :src="handy_sim_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="handy_sim_rueckgabe_date"
                  :disabled="handy_sim_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('handy_sim_rueckgabe')"
              >
                <img
                  v-if="handy_sim_rueckgabe_signature"
                  :src="handy_sim_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
            <!-- -->
            <b-tr>
              <b-td
                >{{ formular_text("sonstiges") }}
                <b-textarea
                  :placeholder="formular_text('sonstiges_eintragen')"
                  v-model="sonstiges_text"
                  size="sm"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="sonstiges_ausgabe_date"
                  :disabled="sonstiges_ausgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('sonstiges_ausgabe')"
              >
                <img
                  v-if="sonstiges_ausgabe_signature"
                  :src="sonstiges_ausgabe_signature"
                />
              </b-td>
              <b-td>
                <b-input
                  type="date"
                  v-model="sonstiges_rueckgabe_date"
                  :disabled="sonstiges_rueckgabe_signature !== null"
                  size="sm"
                />
              </b-td>
              <b-td
                class="signature-field"
                @click="openSignature('sonstiges_rueckgabe')"
              >
                <img
                  v-if="sonstiges_rueckgabe_signature"
                  :src="sonstiges_rueckgabe_signature"
                />
              </b-td>
            </b-tr>
          </table>
        </b-skeleton-wrapper>
      </bx-box>
    </bx-box>

    <bx-box variant="gray" class="mb-3">
      <bx-box variant="white">
        <table class="table table-bordered">
          <tr>
            <th></th>
            <th>{{ formular_text("fachabteilung") }}</th>
            <th>{{ $t("common.date") }}</th>
            <th>
              <div>{{ $t("common.signature") }}</div>
              <div>{{ formular_text("fachabteilung") }}</div>
            </th>
          </tr>
          <tr>
            <td>{{ formular_text("verkaeufernummer") }}</td>
            <td>{{ formular_text("edv") }}</td>
            <td>
              <b-input
                type="date"
                v-model="verkaeufernummer_angelegt_date"
                :disabled="verkaeufernummer_angelegt_signature !== null"
                size="sm"
              />
            </td>
            <b-td
              class="signature-field"
              @click="openSignature('verkaeufernummer_angelegt')"
            >
              <img
                v-if="verkaeufernummer_angelegt_signature"
                :src="verkaeufernummer_angelegt_signature"
              />
            </b-td>
          </tr>
          <tr>
            <td>{{ formular_text("konten_prema") }}</td>
            <td>{{ formular_text("personal") }}/{{ formular_text("edv") }}</td>
            <td>
              <b-input
                type="date"
                v-model="konten_prema_date"
                :disabled="konten_prema_signature !== null"
                size="sm"
              />
            </td>
            <b-td
              class="signature-field"
              @click="openSignature('konten_prema')"
            >
              <img
                v-if="konten_prema_signature"
                :src="konten_prema_signature"
              />
            </b-td>
          </tr>
          <tr>
            <td>{{ formular_text("fahrerkontofuehrung") }}</td>
            <td>{{ formular_text("buchhaltung") }}</td>
            <td>
              <b-input
                type="date"
                v-model="fahrerkontofuehrung_angelegt_date"
                :disabled="fahrerkontofuehrung_angelegt_signature !== null"
                size="sm"
              />
            </td>
            <b-td
              class="signature-field"
              @click="openSignature('fahrerkontofuehrung_angelegt')"
            >
              <img
                v-if="fahrerkontofuehrung_angelegt_signature"
                :src="fahrerkontofuehrung_angelegt_signature"
              />
            </b-td>
          </tr>
          <tr>
            <td>{{ formular_text("tanksystem") }}</td>
            <td>{{ formular_text("technik") }}/{{ formular_text("edv") }}</td>
            <td>
              <b-input
                type="date"
                v-model="tanksystem_angelegt_date"
                :disabled="tanksystem_angelegt_signature !== null"
                size="sm"
              />
            </td>
            <b-td
              class="signature-field"
              @click="openSignature('tanksystem_angelegt')"
            >
              <img
                v-if="tanksystem_angelegt_signature"
                :src="tanksystem_angelegt_signature"
              />
            </b-td>
          </tr>
        </table>
      </bx-box>
    </bx-box>

    <b-button
      v-if="!id"
      variant="primary"
      class="w-100"
      :disabled="errors_activated && $v.$invalid"
      @click="speichern"
    >
      {{ $t("actions.save") }}
    </b-button>

    <token-invalid-modal ref="tokenInvalidModal"></token-invalid-modal>
    <speichern-erfolgreich-modal
      ref="speichernErfolgreichModal"
    ></speichern-erfolgreich-modal>
    <unexpected-error-modal ref="unexpectedErrorModal"></unexpected-error-modal>
    <validation-failure-modal
      ref="validationFailureModal"
    ></validation-failure-modal>
    <b-modal
      ref="signatureModal"
      hide-header
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      centered
    >
      <signature-pad
        ref="signaturePad"
        no-preview
        @signed="setSignature"
        @sign-canceled="closesignature"
      />
    </b-modal>
  </div>
</template>

<script>
  import formular from "@m/formular";
  import api from "@a/index";
  import { DateTime } from "luxon";
  import EventBus from "@/event-bus.js";
  import { OPEN_ACCESS_LAYER } from "@/event-bus";
  import { formularKeys } from "@/services/formulars/formularKeyDecoder";
  import { required } from "vuelidate/lib/validators";
  import SignaturePad from "@c/SignaturePad.vue";
  import _ from "lodash";

  export default {
    name: "Docket",
    metaInfo() {
      const title = this.formular_text("headline");
      return {
        titleTemplate: () => {
          return title;
        },
      };
    },
    components: {
      SignaturePad,
    },
    mixins: [formular],
    data() {
      return {
        docket_id: null,
        signature_mode: null,
        arbeits_umweltschutz_date: null,
        arbeits_umweltschutz_signature: null,
        betriebsausweis_date: null,
        betriebsausweis_signature: null,
        betriebsordnung_date: null,
        betriebsordnung_signature: null,
        betriebsschlussel_ausgabe_date: null,
        betriebsschlussel_ausgabe_signature: null,
        betriebsschlussel_rueckgabe_date: null,
        betriebsschlussel_rueckgabe_signature: null,
        betriebsverkehrsordnung_date: null,
        betriebsverkehrsordnung_signature: null,
        buchhaltung_date: null,
        buchhaltung_signature: null,
        creation_date: null,
        dienstkleidung_ausgabe_date: null,
        dienstkleidung_ausgabe_signature: null,
        dienstkleidung_rueckgabe_date: null,
        dienstkleidung_rueckgabe_signature: null,
        dokumente_date: null,
        dokumente_signature: null,
        einweisung_abrechnung_date: null,
        einweisung_abrechnung_signature: null,
        einweisung_einzahlungen_date: null,
        einweisung_einzahlungen_signature: null,
        einweisung_rbl_date: null,
        einweisung_rbl_signature: null,
        einweisung_tanken_date: null,
        einweisung_tanken_signature: null,
        einweisung_tarifsystem_date: null,
        einweisung_tarifsystem_signature: null,
        employee: null,
        employee_id: null,
        fahrerkontofuehrung_angelegt_date: null,
        fahrerkontofuehrung_angelegt_signature: null,
        fahrscheinsortiment_date: null,
        fahrscheinsortiment_signature: null,
        fahrzeugbordrechner_date: null,
        fahrzeugbordrechner_signature: null,
        fahrzeugeinweisung_date: null,
        fahrzeugeinweisung_signature: null,
        handynummer: null,
        handy_privat: false,
        fahrerdongle_ausgabe_date: null,
        fahrerdongle_ausgabe_signature: null,
        fahrerdongle_rueckgabe_date: null,
        fahrerdongle_rueckgabe_signature: null,
        handynummer_ausgabe_date: null,
        handynummer_ausgabe_signature: null,
        handynummer_rueckgabe_date: null,
        handynummer_rueckgabe_signature: null,
        handy_sim: null,
        handy_sim_ausgabe_date: null,
        handy_sim_ausgabe_signature: null,
        handy_sim_rueckgabe_date: null,
        handy_sim_rueckgabe_signature: null,
        imei: null,
        imei_ausgabe_date: null,
        imei_ausgabe_signature: null,
        imei_rueckgabe_date: null,
        imei_rueckgabe_signature: null,
        infoblatt_betriebliche_alertsvorsorge_date: null,
        infoblatt_betriebliche_alertsvorsorge_signature: null,
        kasse_date: null,
        kasse_signature: null,
        kasseneinsatz_ausgabe_date: null,
        kasseneinsatz_ausgabe_signature: null,
        kasseneinsatz_rueckgabe_date: null,
        kasseneinsatz_rueckgabe_signature: null,
        konten_prema_date: null,
        konten_prema_signature: null,
        modul_ausgabe_date: null,
        modul_ausgabe_signature: null,
        modul_nummer: null,
        modul_rueckgabe_date: null,
        modul_rueckgabe_signature: null,
        monats_wochen_tagesplan_date: null,
        monats_wochen_tagesplan_signature: null,
        qm_system_date: null,
        qm_system_signature: null,
        rfid_im_transponder: null,
        rfid_im_transponder_ausgabe_date: null,
        rfid_im_transponder_ausgabe_signature: null,
        rfid_im_transponder_hinterlegt: null,
        rfid_im_transponder_rueckgabe_date: null,
        rfid_im_transponder_rueckgabe_signature: null,
        sonstiges_ausgabe_date: null,
        sonstiges_ausgabe_signature: null,
        sonstiges_rueckgabe_date: null,
        sonstiges_rueckgabe_signature: null,
        sonstiges_text: null,
        sozialvorschriften_date: null,
        sozialvorschriften_signature: null,
        spind_ausgabe_date: null,
        spind_ausgabe_signature: null,
        spind_nummer: null,
        spind_rueckgabe_date: null,
        spind_rueckgabe_signature: null,
        tanksystem_angelegt_date: null,
        tanksystem_angelegt_signature: null,
        tanktransponder_gesondert_ausgabe_date: null,
        tanktransponder_gesondert_ausgabe_signature: null,
        tanktransponder_gesondert_rfid_nummer: null,
        tanktransponder_gesondert_rueckgabe_date: null,
        tanktransponder_gesondert_rueckgabe_signature: null,
        tarifangelegenheiten_date: null,
        tarifangelegenheiten_signature: null,
        transponder_schliesssystem_ausgabe_date: null,
        transponder_schliesssystem_ausgabe_signature: null,
        transponder_schliesssystem_nummer: null,
        transponder_schliesssystem_rueckgabe_date: null,
        transponder_schliesssystem_rueckgabe_signature: null,
        tresor_ausgabe_date: null,
        tresor_ausgabe_signature: null,
        tresor_nummer: null,
        tresor_rueckgabe_date: null,
        tresor_rueckgabe_signature: null,
        verkaeufernummer_angelegt_date: null,
        verkaeufernummer_angelegt_signature: null,
        wechselgeld_ausgabe_date: null,
        wechselgeld_ausgabe_signature: null,
        wechselgeld_betrag: null,
        wechselgeld_rueckgabe_date: null,
        wechselgeld_rueckgabe_signature: null,
        werkstatt_arbeitsablaeufe_date: null,
        werkstatt_arbeitsablaeufe_signature: null,
        werkstatt_arbeitsbelehrung_date: null,
        werkstatt_arbeitsbelehrung_signature: null,
        fields: [],
      };
    },
    validations() {
      return {
        employee_id: {
          required,
        },
      };
    },
    computed: {
      formular_key() {
        return "employee.docket";
      },
    },
    async created() {
      await this.ladeDaten();
      this.loading = false;
    },
    methods: {
      async ladeDaten() {
        let loader = this.$loading.show({});
        try {
          let response = this.id
            ? await api.privateFormular.employee.docket.getById(this.id)
            : this.token
            ? await api.publicFormluar.employee.docket.get(this.token)
            : null;

          this.initialize(response?.data);
        } catch (e) {
          console.error(e);
          if (e.response.status === 401) {
            this.$refs.tokenInvalidModal.show();
          }
        } finally {
          this.loading = false;
          loader.hide();
        }
      },
      async speichern() {
        if (this.$v.$invalid) {
          this.errors_activated = true;
          this.$refs.validationFailureModal.show();
        } else {
          let loader = this.$loading.show({});

          try {
            let json = this.toJson();
            await api.publicFormluar.employee.docket.post(json, this.token);

            this.$refs.speichernErfolgreichModal.show(false);
          } catch (e) {
            console.error(e);
            if (e.response?.status === 401) {
              this.$refs.tokenInvalidModal.show();
            } else {
              this.$refs.unexpectedErrorModal.show();
            }
          } finally {
            loader.hide();
          }
        }
      },
      // eslint-disable-next-line no-unused-vars

      // eslint-disable-next-line no-unused-vars
      initializeCategories(categories) {},
      // eslint-disable-next-line no-unused-vars
      initializeDocket(docket) {
        _.toPairs(docket).forEach(([k, v]) => {
          if (k === "id") this.docket_id = v;
          else if (k.endsWith("date")) {
            if (v) this[k] = DateTime.fromMillis(v).toFormat("yyyy-MM-dd");
          } else this[k] = v;
        });

        this.fields = _.keys(docket);
      },
      toJson() {
        let json = {};

        this.fields.forEach((field) => {
          if (field === "id") {
            json[field] = this.docket_id;
          } else if (this[field] && typeof this[field] !== "object") {
            if (this.isDate(this[field])) {
              json[field] = DateTime.fromFormat(this[field], "yyyy-MM-dd").ts;
            } else if (
              !this.isSignatureField(field) ||
              this.isSignatureBase64(this[field])
            ) {
              json[field] = this[field];
            }
          }
        });

        return json;
      },
      isSignatureField(field) {
        return field.endsWith("signature");
      },
      isSignatureBase64(value) {
        return value.startsWith("data:image/png;base64,");
      },
      isDate(value) {
        return (
          value &&
          typeof value === "string" &&
          value.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/)
        );
      },
      initialize(responseData) {
        if (responseData) {
          this.initializeCategories(responseData.categories);
          if (responseData.data) {
            this.initializeDocket(responseData.data);
          }
        }
      },
      openSignature(field) {
        if (!this[`${field}_signature`]) {
          this.signature_mode = field;
          this.$refs.signatureModal.show();
        }
      },
      closesignature() {
        this.$refs.signatureModal.hide();
        this.$refs.signaturePad.clear();
      },
      setSignature(signature) {
        this[`${this.signature_mode}_signature`] = signature;
        if (!this[`${this.signature_mode}_date`]) {
          this[`${this.signature_mode}_date`] =
            DateTime.local().toFormat("yyyy-MM-dd");
        }

        this.closesignature();
      },
      generateToken() {
        EventBus.$emit(
          OPEN_ACCESS_LAYER,
          formularKeys.docket,
          "",
          DateTime.local().plus({ days: 1 }),
          this.employee_id
        );
      },
    },
  };
</script>

<style lang="scss" scoped>
  .signature-placeholder {
    height: 100%;
    width: 100%;
  }

  td {
    vertical-align: middle;
    //word-break: break-all;
    overflow-x: hidden;
    hyphens: auto;
    -webkit-hyphens: auto;
    -webkit-hyphenate-limit-chars: auto 3;
    -webkit-hyphenate-limit-lines: 4;
    -ms-hyphens: auto;
    -ms-hyphenate-limit-chars: auto 3;
    -ms-hyphenate-limit-lines: 4;
  }

  .belehrungen-table {
    table-layout: fixed;
    td {
      width: 25%;
    }
  }

  .weitere-belehrungen-table {
    table-layout: fixed;
    td,
    th {
      width: 25%;
    }
  }

  .laufzettel-table {
    table-layout: fixed;
    td,
    th {
      width: 18%;

      &:first-child {
        width: 28%;
      }

      &.disabled {
        background-color: #e9ecef;
      }
    }
  }

  .signature-field {
    padding-top: 3px;
    padding-bottom: 3px;
    img {
      height: 50px;
    }
  }
</style>
